var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('iframe',{attrs:{"width":"100%","height":"100%","src":_vm.src,"frameBorder":"0","allow":"clipboard-write; autoplay","webkitAllowFullScreen":"","mozallowfullscreen":"","allowFullScreen":""}})}
var staticRenderFns = []

export { render, staticRenderFns }